import { TickingDateAgo } from '@components/core-ui/Date/TickingDateAgo';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { JobDtoComment, JobDtoUser } from 'app/API';
import { EntityIconProfile } from '@components/core-ui/EntityIcon/variations/EntityIconProfile';
import { AvatarBlock } from './styles/AvatarBlock';
import { StyledLink } from './styles/StyledLink';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  comments?: JobDtoComment[];
};

export const renderAvatar = (user: JobDtoUser) => {
  if (!user) {
    return '';
  }
  return (
    <AvatarBlock>
      <EntityIconProfile name={`${user.name} ${user.lastname}`} src={user.avatar ?? undefined} />
    </AvatarBlock>
  );
};

export const CommentsList = ({ comments }: TProps) => {
  const { me, organization } = useAuthContext();

  if (!comments?.length) {
    return null;
  }

  return (
    <Wrapper>
      {comments?.map((comment) => (
        <div key={comment.id} className="comment">
          {renderAvatar(comment.creator)}
          <div className="comment-right">
            <div className="comment-title">
              <span className="comment-username">
                {comment.creator.id === me.id ? (
                  <StyledLink to={routes.accountPage.make()}>
                    {comment.creator.name} {comment.creator.lastname}
                  </StyledLink>
                ) : (
                  <StyledLink to={routes.userDetails.make(organization?.slug ?? '', comment.creator.id)}>
                    {comment.creator.name} {comment.creator.lastname}
                  </StyledLink>
                )}
              </span>
              <span className="comment-date">
                <TickingDateAgo date={comment.createdAt} />
              </span>
            </div>
            <div className="comment-text">
              {comment.comment.split('\n').map((c, i) => (
                <p key={i}>{c}</p>
              ))}
            </div>
          </div>
        </div>
      ))}
    </Wrapper>
  );
};
